// @flow
import React from 'react';
import PlusIcon from 'assets/images/Ticketing-Plus-Coral.svg';
import MinusIcon from 'assets/images/Ticketing-Minus-Coral.svg';
import classNames from 'classnames';
//eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  type: string,
  initialValue: number,
  FinalValue: () => void,
  availableTickets: number,
  className: string,
};
const ButtonIncrementDecrement = (props: Props) => {
  const {
    type,
    initialValue = 0,
    FinalValue,
    availableTickets,
    className = '',
  } = props;
  const icon = type === 'increment' ? PlusIcon : MinusIcon;

  const checkButtonDisable = () => {
    if (type === 'increment' && initialValue === availableTickets)
      return 'disable';
    if (type === 'decrement' && initialValue === 0) return 'disable';
  };

  const buttonClass = classNames(
    'increment-decrement-button',
    className,
    checkButtonDisable()
  );

  const modifyValue = () => {
    if (type === 'increment') IncreaseValue();
    else DecreaseValue();
  };

  const IncreaseValue = () => {
    if (initialValue < availableTickets) FinalValue(initialValue + 1);
  };

  const DecreaseValue = () => {
    if (initialValue > 0) FinalValue(initialValue - 1);
  };

  return (
    <button onClick={modifyValue} className={buttonClass}>
      <img src={icon} alt={'increment-decrement-icon'} />
    </button>
  );
};
export default ButtonIncrementDecrement;
